import classNames from 'classnames';
import { FormikProps } from 'formik';
import React, { MouseEventHandler, ReactNode } from 'react';
import Dropzone, { DropzoneProps, FileRejection } from 'react-dropzone';

import { useToasts } from '@sbu/contexts.toasts';
import { Button } from '@sumologic/yama-ds-components';

import { FormValues } from './FileUpload';
import css from './FileUpload.module.scss';

export interface FileUploadFieldProps {
  dropzoneProps?: DropzoneProps;
  message?: ReactNode;
  removeLabel?: ReactNode;
  setFieldValue: FormikProps<FormValues>['setFieldValue'];
  values: FormValues;
}

export function FileUploadField({
  dropzoneProps,
  message = 'Drop your CSV file or click here to import',
  removeLabel = 'Remove File',
  setFieldValue,
  values,
}: FileUploadFieldProps) {
  const { addError } = useToasts();

  const handleDrop = (
    [acceptedFile]: File[],
    [rejectedFile]: FileRejection[]
  ) => {
    rejectedFile
      ? addError(rejectedFile.errors[0].message)
      : setFieldValue('file', acceptedFile);
  };

  const handleRemove: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setFieldValue('file', undefined);
  };

  return (
    <div className={classNames(css.formRow, css.dropzoneContainer)}>
      <Dropzone multiple={false} onDrop={handleDrop} {...dropzoneProps}>
        {({ getRootProps, getInputProps }) => (
          <div className={css.dropzone} {...getRootProps()}>
            <input name='file' {...getInputProps()} />
            <div className={css.messageContainer}>
              <div>
                {values.file ? (
                  <>
                    <span className={css.selectedLabel}>Selected:</span>
                    {values.file.name}
                  </>
                ) : (
                  message
                )}
              </div>
              {values.file && (
                <Button
                  variant='text'
                  className={css.removeFile}
                  onClick={handleRemove}
                  tabIndex={-1}
                >
                  {removeLabel}
                </Button>
              )}
            </div>
          </div>
        )}
      </Dropzone>
    </div>
  );
}
